import axios from "axios";


// const baseURL = "https://impapiprod.azurewebsites.net/";
// const baseURL = "http://localhost:63130/api";

//const baseURL = "http://172.21.1.223:8989/api";

// const baseURL = "http://172.21.1.213:9091/api";
// produccion
const baseURL = "https://190.223.56.84/api";
// PRODUCCION LOCA
// const baseURL = "https://api1.imperu.local:8042/api";

//  dev
  // const baseURL = "http://localhost:49684/api";

export default axios.create({
    baseURL,
});